var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMapGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M.675 1.746 4.5 3.153l.187-.07a3.75 3.75 0 0 0-.006.305c0 .395.121.845.318 1.316L5 11.803l2.999-1.104.002-1.67.13.14a.61.61 0 0 0 .45.191c.137 0 .27-.046.375-.128L9 9.19V10.7l3 1.104V5.055c.29-.598.48-1.178.48-1.673v-.135c.324.274.52.678.52 1.114v8.148c0 .271-.224.491-.5.491a.51.51 0 0 1-.175-.03L8.5 11.563l-3.825 1.409-.07.018a.506.506 0 0 1-.015.003L4.5 13a.511.511 0 0 1-.175-.03L1 11.735a1.474 1.474 0 0 1-1-1.378V2.208c0-.162.08-.313.214-.405a.508.508 0 0 1 .461-.057zM1 2.914v7.442c0 .205.129.39.325.461L4 11.798v-7.78L1 2.914zM8.5 0c1.828.038 3.28 1.518 3.25 3.311 0 1.698-2.58 4.587-2.875 4.906a.503.503 0 0 1-.29.16l-.085.007a.505.505 0 0 1-.375-.162C7.83 7.898 5.25 5.009 5.25 3.316 5.217 1.521 6.67.038 8.5 0zm0 1.629a1.56 1.56 0 1 0 0 3.12 1.56 1.56 0 0 0 0-3.12z",
    id: "a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.5 .5)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#282828",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)",
    fill: "#02751A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-6.5-6.5h26v26h-26z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapGreen);
export default __webpack_public_path__ + "static/media/map-green.99ccfb69ff09432c88c9468170ede585.svg";
export { ForwardRef as ReactComponent };